const CELLS = [
  { key: "scheduled", label: "Scheduled" },
  { key: "executing", label: "Firing" },
  { key: "success", label: "Registered" },
  { key: "failed", label: "Failed" },
  { key: "success_rate", label: "Success Rate", suffix: "%" },
];

export default function StatsRow({ stats }) {
  return (
    <div
      className="grid grid-cols-5 border-b border-[#eaecf0]"
      data-testid="stats-row"
    >
      {CELLS.map((c, i) => (
        <div
          key={c.key}
          className={`px-6 py-5 ${i < CELLS.length - 1 ? "border-r border-[#eaecf0]" : ""}`}
          data-testid={`stat-${c.key}`}
        >
          <div className="overline mb-2">{c.label}</div>
          <div className="font-mono text-2xl font-medium text-[#101828] tabular-nums">
            {stats?.[c.key] ?? 0}
            {c.suffix || ""}
          </div>
        </div>
      ))}
    </div>
  );
}
